module.exports = __webpack_public_path__ + "static/hero-mask-f852020573bc6bae8961690dd22fee3b.png";